// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0567190e","977":"385295ff"}[chunkId] + ".chunk.js";
};